module.exports = __webpack_public_path__ + "static/media/nextArrowDark.525cfbd0.svg";